module.exports = __webpack_public_path__ + "static/media/wechat.5dcff4ab.jpeg";